import { render, staticRenderFns } from "./NavigationPortal.vue?vue&type=template&id=348331c4&scoped=true&"
import script from "./NavigationPortal.vue?vue&type=script&lang=js&"
export * from "./NavigationPortal.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPortal.vue?vue&type=style&index=0&id=348331c4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348331c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348331c4')) {
      api.createRecord('348331c4', component.options)
    } else {
      api.reload('348331c4', component.options)
    }
    module.hot.accept("./NavigationPortal.vue?vue&type=template&id=348331c4&scoped=true&", function () {
      api.rerender('348331c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/NavigationPortal.vue"
export default component.exports